import liuEnv from "~/utils/liu-env"

const env = liuEnv.getEnv()
const d = env.API_DOMAIN ?? ""

export default {
  TIME: d + `hello-world`,
  LOGIN: d + `user-login`,
  LOGOUT: d + `user-settings`,
  USER_ENTER: d + `user-settings`,
  USER_LATEST: d + `user-settings`,
  USER_SET: d + `user-settings`,
  USER_MEMBERSHIP: d + `user-settings`,
  WECHAT_BIND: d + `user-settings`,
  SUBSCRIBE_PLAN: d + `subscribe-plan`,
  REQUEST_REFUND: d + `subscribe-plan`,
  UPLOAD_FILE: d + `file-set`,
  SYNC_SET: d + `sync-set`,
  SYNC_GET: d + `sync-get`,
  SYNC_OPERATE: d + `sync-operate`,
  OPEN_CONNECT: d + `open-connect`,
  PAYMENT_ORDER: d + `payment-order`,
  SERVICE_POLY: d + `service-poly`,
  BIND_DATA: d + `user-settings`,
  GET_LAST_EVENTS_SUBSCRIPTION: d + `get-last-events-subscription`,
  SET_LAST_EVENTS_SUBSCRIPTION: d + `set-last-events-subscription`,
  GET_CALENDAR_EVENTS: env.WSCN_API_DOMAIN + 'apiv1/finance/calendar/importance',
  GET_WX_CONFIG: d + `get-wx-config`,
  GET_CALENDAR_SUBSCRIBE_NOTIFICATION:d + `get-calendar-subscribe-notification`,
  SET_CALENDAR_SUBSCRIBE_NOTIFICATION:d + `set-calendar-subscribe-notification`,
  SET_CALENDAR_AGENDA: d + `set-calendar-agenda`,
  GET_CALENDAR_AGENDA: d + `get-calendar-agenda`,
  EXTRACT_CALENDAR: d + `extract-agenda`
}